export default __webpack_public_path__ + "static/media/Webfm.f913cb50.png";